import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { fetchCart } from '@/lib/api';
import { CartType } from '@/types/cart';
type ParamsType = {
  queryEnabled?: boolean;
};
const useCart = t0 => {
  const $ = _c(5);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    queryEnabled: t2
  } = t1;
  const queryEnabled = t2 === undefined ? true : t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["cart"];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== queryEnabled) {
    t4 = {
      queryKey: t3,
      queryFn: _temp,
      enabled: queryEnabled
    };
    $[3] = queryEnabled;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return useQuery(t4);
};
export default useCart;
async function _temp() {
  return fetchCart();
}